<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
import PartnerList from '@/components/page-partners/PartnerList.vue';
import { promiseAll, calculatePromise } from '@/api/default.js';

export default {
    name: 'PartnersPage',

    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        PartnerList,
    },

    async mounted() {
        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            { dispatch: 'loadPartners', commit: null, isArray: false },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
            <hr class="left-separator" />
            <label class="chapter_header">Partners</label>
        </LeftPanel>
        <RightContainer>
            <h2>Partner Management</h2>
            <PartnerList />
        </RightContainer>
    </MainContainer>
</template>
